<template>
  <a-popover placement="top" trigger="hover" overlay-class-name="dns-challenge-popover">
    <template slot="content">
      <div class="dns-challenge">
        <div class="dns-challenge__title">
          <a-icon type="safety-certificate" /> {{ $t('cert.DNSChallengeTitle') }}
        </div>
        <div class="dns-challenge__hint">{{ $t('cert.DNSChallengeHint') }}</div>

        <div v-for="(opt, i) in options" :key="i" class="dns-challenge__option">
          <div class="dns-challenge__covers">{{ $t('cert.DNSChallengeCovers', { scope: opt.covers }) }}</div>

          <div class="dns-challenge__row">
            <span class="dns-challenge__label">{{ $t('cert.DNSChallengeType') }}</span>
            <code class="dns-challenge__type">CNAME</code>
          </div>

          <div class="dns-challenge__row">
            <span class="dns-challenge__label">{{ $t('cert.DNSChallengeHost') }}</span>
            <a-input class="dns-challenge__input" readonly :value="opt.host" size="small"
                     @focus="$event.target.select()" />
            <a-tooltip :title="$t('Copied')" :visible="copied === i + '-host'">
              <a-button class="dns-challenge__copy" size="small" @click="copy(opt.host, i + '-host')">
                <a-icon type="copy" />
              </a-button>
            </a-tooltip>
          </div>

          <div class="dns-challenge__row">
            <span class="dns-challenge__label">{{ $t('cert.DNSChallengeValue') }}</span>
            <a-input class="dns-challenge__input" readonly :value="opt.value" size="small"
                     @focus="$event.target.select()" />
            <a-tooltip :title="$t('Copied')" :visible="copied === i + '-value'">
              <a-button class="dns-challenge__copy" size="small" @click="copy(opt.value, i + '-value')">
                <a-icon type="copy" />
              </a-button>
            </a-tooltip>
          </div>
        </div>
      </div>
    </template>
    <slot />
  </a-popover>
</template>

<script>
export default {
  name: 'DnsChallengePopover',
  props: {
    // [{ host, value, covers }] — one CNAME delegation option per cert scope
    options: { type: Array, default: () => [] },
  },
  data() {
    return { copied: null };
  },
  methods: {
    copy(text, key) {
      const done = () => {
        this.copied = key;
        setTimeout(() => { this.copied = null; }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopy(text, done));
      } else {
        this.fallbackCopy(text, done);
      }
    },
    fallbackCopy(text, done) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try {
        document.execCommand('copy');
        done();
      } catch (e) {
        /* clipboard unavailable — the input is selectable for manual copy */
      } finally {
        document.body.removeChild(ta);
      }
    },
  },
};
</script>

<style scoped>
.dns-challenge {
  max-width: 400px;
}
.dns-challenge__title {
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 4px;
}
.dns-challenge__hint {
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  margin-bottom: 10px;
}
.dns-challenge__option + .dns-challenge__option {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}
.dns-challenge__covers {
  font-size: 12px;
  font-weight: 600;
  color: #1f6feb;
  margin-bottom: 6px;
}
.dns-challenge__row {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.dns-challenge__row:last-child {
  margin-bottom: 0;
}
.dns-challenge__label {
  flex: 0 0 52px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 12px;
}
.dns-challenge__type {
  font-family: monospace;
  font-size: 12px;
  background: #f5f5f5;
  padding: 1px 8px;
  border-radius: 3px;
}
.dns-challenge__input {
  flex: 1 1 auto;
}
.dns-challenge__input >>> input {
  font-family: monospace;
  font-size: 12px;
}
.dns-challenge__copy {
  margin-left: 6px;
  flex: 0 0 auto;
}
</style>
